import { createContext, useContext } from "react";

// Sdílený globální stav appky (token, licence, produkty, skupiny, filtry, modaly).
// Hodnotu poskytuje App.jsx, konzumují ji layout/ a pages/.
export const AppContext = createContext(null);

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp musí být uvnitř <AppContext.Provider>");
  return ctx;
}
